import React from 'react';
import { Reveal } from './motion';
import { DEMO_EMAIL } from './brand';

const INCLUDED = [
  'The web app plus the iOS & Android companion',
  'Every role \u2014 athlete, coxswain, coach, admin',
  'Your colors, your logo, your river gauge, your GMS standards',
  'CSV import so last season comes with you',
];

export default function Pricing({ onRequestDemo }) {
  return (
    <section id="pricing" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-6xl safe-area-x sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">Pricing</p>
            <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Sized to your club.
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              A 200-athlete collegiate program and a 30-person masters club don&rsquo;t need the same
              thing, and shouldn&rsquo;t pay the same either. Tell us how big you are and how you row,
              and we&rsquo;ll come back with a plan that fits.
            </p>
            <p className="mt-4 text-sm text-slate-500">
              Prefer to just write to us?{' '}
              <a
                href={`mailto:${DEMO_EMAIL}`}
                className="font-semibold text-blue-600 underline-offset-4 hover:underline"
              >
                {DEMO_EMAIL}
              </a>
            </p>
          </Reveal>

          <Reveal delay={0.12} y={32}>
            <div className="relative overflow-hidden rounded-3xl bg-slate-950 p-8 shadow-2xl shadow-slate-900/20 sm:p-10">
              <div
                className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-blue-600/30 blur-3xl"
                aria-hidden="true"
              />
              <div className="relative">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-medium text-sky-200">
                  Custom plans
                </span>
                <h3 className="mt-5 text-2xl font-bold text-white">Talk to us for a number</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">
                  A 20-minute walkthrough of your actual season &mdash; your boats, your squads, your
                  testing schedule.
                </p>

                <ul className="mt-7 space-y-3">
                  {INCLUDED.map((item) => (
                    <li key={item} className="flex gap-3 text-sm text-slate-300">
                      <svg
                        className="mt-0.5 h-4 w-4 shrink-0 text-sky-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={onRequestDemo}
                  className="mt-8 w-full rounded-xl bg-white px-6 py-3.5 text-base font-semibold text-slate-900 transition-transform hover:scale-[1.02] active:scale-95"
                >
                  Request a demo
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
